import c from "@/constants";
import filters from "./filters";

const toggleFullScreen = () => {
  let doc = window.document;
  let docEl = doc.documentElement;

  let requestFullScreen =
    docEl.requestFullscreen ||
    docEl.mozRequestFullScreen ||
    docEl.webkitRequestFullScreen ||
    docEl.msRequestFullscreen;
  let cancelFullScreen =
    doc.exitFullscreen ||
    doc.mozCancelFullScreen ||
    doc.webkitExitFullscreen ||
    doc.msExitFullscreen;

  if (
    !doc.fullscreenElement &&
    !doc.mozFullScreenElement &&
    !doc.webkitFullscreenElement &&
    !doc.msFullscreenElement
  ) {
    requestFullScreen.call(docEl);
  } else {
    cancelFullScreen.call(doc);
  }
};

const ls = {
  get: item => {
    return localStorage.getItem(c.STORAGE_KEY + item);
  },
  set: (item, value) => {
    return localStorage.setItem(c.STORAGE_KEY + item, value);
  },
  remove: item => {
    return localStorage.removeItem(c.STORAGE_KEY + item);
  },
  clear: () => {
    return localStorage.clear();
  }
};

export default {
  filters,
  toggleFullScreen,
  ls
};
